import { appConfig } from './app.config';
import qs from 'qs';
import axios from 'axios';

export class HubspotService {
    getCookie = (name) => {
        const value = `; ${document.cookie}`;
        const parts = value.split(`; ${name}=`);
        if (parts.length === 2) return parts.pop().split(';').shift();
     };
    submitForm(fields, formGuid) {

        const hutk = this.getCookie('hubspotutk'); // HubSpot tracking cookie

        const url = `https://forms.hubspot.com/uploads/form/v2/${appConfig.hubspotPortalId}/${formGuid}`;
        
        const formData = {
            fields: fields,
            context: {
                hutk: hutk, 
                pageUri: window.location.href,
                pageName: document.title
              }
        };

        const d = {};
        
        for (let p in formData) {
            if (!data[p]) {
                continue;
            }
            d[encodeURIComponent(p)] = encodeURIComponent(data[p]);
        }

        const options = {
            method: 'POST',
            headers: { 'content-type': 'application/x-www-form-urlencoded' },
            data: qs.stringify(d),
            url,
        };
        axios(options)
        .then((response) => {
           return true;
        })
        .catch((err) => {
           return err;   
        });
    }

    submitFormV3(fields, formGuid) {

        const hutk = this.getCookie('hubspotutk'); // HubSpot tracking cookie

        const url = `https://api.hsforms.com/submissions/v3/integration/submit/${appConfig.hubspotPortalId}/${formGuid}`;
        
        const formData = {
            fields: fields,
            context: {
                hutk: hutk, 
                pageUri: window.location.href,
                pageName: document.title
              }
        };

        const options = {
            method: 'POST',
            headers: { 'content-type': 'application/json' },
            data: JSON.stringify(formData),
            url,
        };

        return axios(options)
            .then((response) => {
                return true;
            })
            .catch((err) => {
                return err;   
            });
    }
}